import { render, staticRenderFns } from "./AppIdentityEmailCheckModal.vue?vue&type=template&id=71b10d26&scoped=true"
import script from "./AppIdentityEmailCheckModal.vue?vue&type=script&lang=js"
export * from "./AppIdentityEmailCheckModal.vue?vue&type=script&lang=js"
import style0 from "./AppIdentityEmailCheckModal.vue?vue&type=style&index=0&id=71b10d26&lang=scss"
import style1 from "./AppIdentityEmailCheckModal.vue?vue&type=style&index=1&id=71b10d26&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b10d26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71b10d26')) {
      api.createRecord('71b10d26', component.options)
    } else {
      api.reload('71b10d26', component.options)
    }
    module.hot.accept("./AppIdentityEmailCheckModal.vue?vue&type=template&id=71b10d26&scoped=true", function () {
      api.rerender('71b10d26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/develop-manage/components/Modal/AppIdentityEmailCheckModal.vue"
export default component.exports